<template>
  <v-row>
    <v-col
      v-for="reason in reasonsWithLocations"
      :key="reason.reasonId"
      cols="12"
      lg="3"
      md="6"
      sm="12">
      <LocationValueList
        :icon="ReceiptRefundIcon"
        :rows="reason.rows"
        :title="reason.reason"
        :total="reason.total" />
    </v-col>
  </v-row>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { ReceiptRefundIcon } from 'vue-tabler-icons';
import { useMetricsStore } from '@/stores/metrics';
import { currencyService } from '@/services/currency';
import LocationValueList from '@/components/metrics/LocationValueList.vue';

const metricsStore = useMetricsStore();

const isLoading = computed(() => Object.values(metricsStore.loadingStates).some((loading) => loading));

const reasonsWithLocations = computed(() => {
  const reasonMap = new Map<number, { reasonId: number; reason: string }>();

  Object.values(metricsStore.metrics).forEach((locationData) => {
    locationData.schoolFeeReductionsByType.forEach((item) => {
      if (!reasonMap.has(item.reasonId)) {
        reasonMap.set(item.reasonId, { reasonId: item.reasonId, reason: item.reason });
      }
    });
  });

  const sortedLocationNames = Object.keys(metricsStore.metrics).sort((a, b) => a.localeCompare(b, 'de'));

  return [...reasonMap.values()].map((r) => {
    const items = sortedLocationNames.map((name) => {
      const item = metricsStore.metrics[name].schoolFeeReductionsByType.find((i) => i.reasonId === r.reasonId);

      return { name, count: item?.count ?? 0, total: item?.total ?? 0 };
    });

    const buildRow = (name: string, count: number, total: number) => ({
      name,
      value: currencyService.formatNumberToCurrency(total),
      subText: `${count} Schüler`,
      isLoading: isLoading.value,
      dimmed: total === 0
    });

    return {
      ...r,
      rows: items.map((item) => buildRow(item.name, item.count, item.total)),
      total: buildRow(
        'Gesamt',
        items.reduce((sum, item) => sum + item.count, 0),
        items.reduce((sum, item) => sum + item.total, 0)
      )
    };
  });
});
</script>
